import { withInstall } from '@klondpay/utils';
import transDetail from './TransDetail.vue';

export const TransDetail = withInstall(transDetail);
export { useDetailsData, getDetailsByAbil } from './use-details-data';
export default TransDetail;
